var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v("Tarifa")])]),_c('b-col',{attrs:{"md":"8"}},[_c('b-form-input',{attrs:{"value":_vm.nombreTarifa,"disabled":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }